import React from "react";
import { VictoryLabel } from "victory";
import { translate as t } from "../../../../../../infrastructure/translate/localization";

export default function AdhesionRateChartTooltip(props) {
  return (
    <VictoryLabel
      {...props}
      text={({ datum }) => [
        `${datum.x}`,
        `${datum.y}%`,
        `${datum.loadedEmployees} ${t("common-messages.loaded-plural")}`,
        `${datum.activeEmployees} ${t("common-messages.active-plural")}`,
        " ",
      ]}
      style={[
        { fontSize: 12, fontFamily: "Roboto" },
        { fontSize: 18, fontFamily: "Roboto", fontWeight: "bold" },
      ]}
      lineHeight={1.2}
    />
  );
}
